import React, {Component} from 'react';
import {Button, Input, Select, DatePicker, Table, message} from 'antd';
import moment from 'moment';
import {Link} from 'react-router-dom';
import {Redirect} from 'react-router';
import utils from '../../../utils/common';
import './style.less';

const Option = Select.Option;
const {RangePicker} = DatePicker;
const dateFormat = 'YYYY-MM-DD';
class TopupList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: 0,
      topupData: [],
      firstStatusData: ['审核中', '审核通过', '审核不通过'],
      secondStatusData: ['审核中', '审核通过', '审核不通过'],
      invoiceTypeData: ['不开发票', '增值税普票-纸制', '增值税普票-电子', '增值税专票'],
      isLoading: true,
      redirect: false,
      allowclear: true,
      moments: [],
      checkStatus: null,
      search: {
        agent_no: null,
        start_time: null,
        end_time: null,
        invoice_type: null,
        recharge_type: null
      },
      pagination: {
        page_size: 10,
        current_page: 1,
        total: null,
        onChange: this.changePage
      }
    };
  }
  componentWillMount() {
    this.loadList();
  }
  loadList = () => {
    const {search, pagination, checkStatus} = this.state;
    let params = {
      page_size: pagination.page_size,
      current_page: pagination.current_page,
      ...search
    };
    params = utils.dealElement(params);
    if (checkStatus !== null) {
      params = Object.assign(params, {second_check_status: '2, 3'});
      //delete params.first_check_status;
    } else {
      params = Object.assign(params, {second_check_status: 1});
      //delete params.second_check_status;
    }
    window.api('eps.getrechargelist', params).then(rs => {
      const p = Object.assign(pagination, {total: Number(rs.total_result)});
      this.setState({topupData: rs.recharge_List, pagination: p, isLoading: false});
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
      this.setState({isLoading: false});
    });
  }
  // 按条件获取列表
  changePage = (page) => {
    const pagination = this.state.pagination;
    page = page === 0 ? 1 : page;
    const p = Object.assign(pagination, {current_page: page});
    this.setState({pagination: p});
    this.loadList();
  }
  async selTap(index) {
    if (index === 1) {
      await this.setState({checkStatus: '2'});
    } else {
      await this.setState({checkStatus: null});
    }
    const search = Object.assign(this.state.search, {
      agent_no: null,
      invoice_type: null,
      start_time: null,
      end_time: null,
      recharge_type: null
    });
    const moments = this.state.moments;
    moments.length = 0;
    //this.setState({search, moments});
    this.setState({isActive: index, search, moments});
    this.loadList();
  }
  changeFormEvent = (type, e, value) => {
    let search = this.state.search;
    if (e === undefined) return false;
    let obj = {};
    let moments = [];
    switch (type) {
      case 'date':
        obj = {start_time: value[0], end_time: value[1]};
        moments = value;
        break;
      case 'agent_no':
        obj = {[type]: e.target.value};
        break;
      case 'invoice_type':
        obj = {[type]: e};
        break;
      case 'recharge_type':
        obj = {[type]: e};
        break;
      default:
        obj = {[type]: e};
        break;
    }
    search = Object.assign(search, obj);
    this.setState({search, moments});
  }
  searchEvent = () => {
    this.loadList();
  }
  clearEvent = () => {
    const search = Object.assign(this.state.search, {
      agent_no: null,
      invoice_type: null,
      start_time: null,
      end_time: null,
      recharge_type: null
    });
    const moments = this.state.moments;
    moments.length = 0;
    this.setState({search, moments});
  }
  render() {
    const {
      isActive,
      topupData,
      search,
      firstStatusData,
      secondStatusData,
      invoiceTypeData,
      pagination,
      isLoading,
      redirect,
      allowclear,
      moments
    } = this.state;
    const rechargType = isActive === 1 ? {
      title: '转账方式',
      key: 'recharge_type',
      dataIndex: 'recharge_type',
      render: (record) => (
        <span>{Number(record) === 1 ? '返佣账号充值' : '线下转账'}</span>
      )
    } : {};
    const columns = [
      {
        title: '创建时间',
        key: 'gmt_created',
        dataIndex: 'gmt_created',
      },
      {
        title: '代理商ID/名称',
        key: 'angentNo',
        dataIndex: '',
        render: (record) => (
          <span>{record.agent_no}/{record.agent_name}</span>
        )
      },
      {
        title: '充值金额',
        key: 'recharge_amt',
        dataIndex: 'recharge_amt'
      },
      rechargType,
      {
        title: '是否开票',
        key: 'type',
        dataIndex: '',
        render: (record) => (
          <span>{Number(record.invoice_type) === 0 ? '否' : '是'}</span>
        )
      },
      {
        title: '发票类型',
        key: 'type2',
        render: (record) => (
          <span>{invoiceTypeData[Number(record.invoice_type)]}</span>
        )
      },
      {
        title: '初审状态',
        key: 'first_check_status',
        dataIndex: 'first_check_status',
        render: (record) => {
          const text = record !== null ? firstStatusData[Number(record) - 1] : '--';
          if (Number(record) === 2) return <span className="status-badge status-success">{text}</span>;
          if (Number(record) === 3) return <span className="status-badge status-danger">{text}</span>;
          return <span className="status-badge status-pending">{text}</span>;
        }
      },
      {
        title: '复审状态',
        key: 'second_check_status',
        dataIndex: 'second_check_status',
        render: (record) => {
          const text = record !== null ? secondStatusData[Number(record) - 1] : '--';
          if (Number(record) === 2) return <span className="status-badge status-success">{text}</span>;
          if (Number(record) === 3) return <span className="status-badge status-danger">{text}</span>;
          return <span className="status-badge status-pending">{text}</span>;
        }
      },
      {
        title: '操作',
        key: 'opeartion',
        dataIndex: '',
        render: (record) => (
          <div className="opeartion">
            <Link to={{pathname: '/main/detail', state: {id: record.id, type: isActive}}}>详情</Link>
            {this.state.isActive === 0 ? <Link className="ml10" to={{pathname: '/main/check', state: {id: record.id}}}>审核</Link> : null}
          </div>
        )
      }
    ];
    if (redirect) return (<Redirect to="/login" />);
    return (
      <div className="topup-blocks topup-list-page">
        <div className="topup-header">
          <h1 className="topup-page-title">充值管理</h1>
          <p className="topup-page-desc">{isActive === 0 ? '待审核的充值记录' : '历史审核记录'}</p>
        </div>
        <div className="nav-items topup-tabs">
          <div className="tap-items">
            <span onClick={() => this.selTap(0)} className={isActive === 0 ? 'active' : ''}>充值审核</span>
            <span onClick={() => this.selTap(1)} className={isActive === 1 ? 'active' : ''}>审核记录</span>
          </div>
        </div>
        <div className="search-blocks topup-search-card">
          <div className="search-row">
            <div className="search-item">
              <label className="search-label">代理商ID：</label>
              <Input
                className="search-input w200"
                placeholder="请输入代理商ID"
                onChange={this.changeFormEvent.bind(this, 'agent_no')}
                value={search.agent_no}
              />
            </div>
            <div className="search-item">
              <label className="search-label">创建时间：</label>
              <RangePicker
                value={search.start_time === null || search.end_time === null ? null : [moment(search.start_time, dateFormat), moment(search.end_time, dateFormat)]}
                format={dateFormat}
                allowClear={allowclear}
                separator="至"
                className="search-input w200"
                onChange={this.changeFormEvent.bind(this, 'date')}
              />
            </div>
            <div className="search-item">
              <label className="search-label">发票类型：</label>
              <Select
                className="search-select w180"
                value={search.invoice_type}
                onChange={this.changeFormEvent.bind(this, 'invoice_type')}
              >
                <Option value={null}>全部</Option>
                <Option value={0}>不开发票</Option>
                <Option value={1}>增值税普票-纸制</Option>
                <Option value={2}>增值税普票-电子</Option>
                <Option value={3}>增值税专票</Option>
              </Select>
            </div>
            {isActive === 1 && (
              <div className="search-item">
                <label className="search-label">转账方式：</label>
                <Select
                  className="search-select w180"
                  value={search.recharge_type}
                  onChange={this.changeFormEvent.bind(this, 'recharge_type')}
                >
                  <Option value={null}>全部</Option>
                  <Option value={1}>返佣账号充值</Option>
                  <Option value={2}>线下转账</Option>
                </Select>
              </div>
            )}
            <div className="search-actions">
              <Button type="primary" className="btn-search" onClick={this.searchEvent.bind(this)}>查询</Button>
              <Button className="btn-clear" onClick={this.clearEvent.bind(this)}>清空</Button>
            </div>
          </div>
        </div>
        <div className="topup-table-card">
          <Table
            columns={columns}
            dataSource={topupData}
            pagination={pagination}
            rowKey={record => record.id}
            className="table-items"
            loading={isLoading}
            scroll={{x: 1000}}
          />
        </div>
      </div>
    );
  }
}
export default TopupList;



// WEBPACK FOOTER //
// ./src/containers/backEnd/topupMangement/topuplist.jsx